export enum RoleType {
  Super_Administrator = 'Super Administrator',
  Agent = 'Agent',
  Test_Manager = 'Test Manager',
  Automation_Engineer = 'Automation Engineer/Developer',
  Test_Lead = 'Test Lead',
}
